export default __webpack_public_path__ + "static/media/bluehousepng.163610c3.png";